import { useDeferredValue, useEffect, useMemo, useState } from "react";

import { nodeToMathMl } from "@/components/expression/MathMlAnnotation";
import { loadSpeechEngine } from "@/components/expression/utils/loadSpeechEngine";

import type { SpeechEngine } from "@/components/expression/utils/loadSpeechEngine";
import type { NodeModel } from "@/models/nodes/types";

/**
 * Spoken text for `node`, generated by Speech Rule Engine.
 *
 * NVDA reads a MathML element referenced by `aria-labelledby` as flat text, so a label has to be
 * the words themselves. Returns `undefined` until the engine and its rules have loaded.
 */
export function useMathSpeech(node: NodeModel | undefined): string | undefined {
  const [engine, setEngine] = useState<SpeechEngine>();

  useEffect(() => {
    loadSpeechEngine().then(setEngine, (error: unknown) => {
      console.error("Failed to load the math speech engine", error);
    });
  }, []);

  // Speech generation re-parses the whole expression, so let it land after the keystroke.
  const mathMl = useDeferredValue(node ? nodeToMathMl(node) : "");

  return useMemo(() => (engine && mathMl ? engine.toSpeech(mathMl) : undefined), [engine, mathMl]);
}
